export default __webpack_public_path__ + "static/media/shape1.7ad2ed87.svg";